// extracted by mini-css-extract-plugin
export var closeButton = "_48-3";
export var header = "_48-0";
export var link = "_48-1";
export var retryButton = "_48-2";